module.exports = __webpack_public_path__ + "img/about4.0a2dd4ac.jpg";